import * as React from "react";
import { useState } from "react";

import {
    Datagrid,
    Show, 
    TextField, 
    ArrayField,
    TabbedForm,
    FormTab,
    FunctionField,
    
} from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import '../../assets/styles/users_show.css'





const useStyles = makeStyles({
    comment: {
        maxWidth: "20em",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    tab: {
        maxWidth: "40em",
        display: "block",
    },
});


;

const Aside = (props) => (
    <div className="aside-container">
        <div className="operation_title">
            <p>Operation locations</p>
        </div>
        <ArrayField source="userOperationLocation">
            <Datagrid>
                <TextField source="zipCode" />
                <TextField source="radius" />
            </Datagrid>
        </ArrayField>
    </div>
);





const ShowTitle = ({ record }) => {
    return <span> {record ? `${record.userName}` : ""}</span>;
};

const AsignData = (props) => {
    props.Asigner(props.data);
    return null;
};


export const UserShow = (props) => {
    const classes = useStyles();
    const [records, setData] = useState([]);

    return (
        <Show {...props} title={<ShowTitle />} aside={<Aside {...props} />} actions={<AsignData Asigner={setData} />}>
            <TabbedForm>
                <FormTab label="Identity" contentClassName={classes.tab}>
                    <div className="flex-2">
                    <small className="title">User Name</small>
                    <TextField className="element" label="User Name" source="userName" />    
                    </div>

                    <div className="flex-2">
                    <small className="title">Mobile Number</small>  
                    <TextField className="element" label="Mobile Number"  source="mobileNumber" />    
                     </div>

                    <div className="flex-2">
                    <small className="title">Email</small>    
                    <TextField className="element" label="Email"  source="email" />    
                    </div>


                    <div className="flex-2">
                    <small className="title">First Address</small>   
                    <FunctionField className="element" label="second Address" render={(record) => `${record.address_one}, ${record.city}, ${record.state} ${record.zipcode}`} />
                    </div>

                    <div className="flex-2">
                    <small className="title">Second Address</small>   
                    <FunctionField className="element" label="second Address" render={(record) => `${record.address_two}, ${record.city}, ${record.state} ${record.zipcode}`} />
                    </div>
                </FormTab>
                {records?.storeName && (
                    <FormTab label="Store" path="Store" contentClassName={classes.tab}>
                        <div className="flex-2">
                            <small className="title">Store Name</small>
                            <TextField  label="storeName" source="storeName" />    
                        </div>

                        <div className="flex-2">
                            <small className="title">Store Rate</small>
                            <TextField label="Rate" source="rate" />
                        </div>
                       
                        
                    </FormTab>
                )}

                <FormTab label="Details" path="Details" contentClassName={classes.tab}>
                        <div className="flex-2">
                            <small className="title">Number of users rated</small>
                            <TextField  label="numberOfUsersRated" source="numberOfUsersRated" />    
                        </div>

                        <div className="flex-2">
                            <small className="title">Provide staging</small>
                            <TextField  label="isProvideStaging" source="isProvideStaging" />    
                        </div>
                   
                </FormTab>
                <FormTab label="Stripe data" path="Stripe data" contentClassName={classes.tab}>
                        <div className="flex-2">
                            <small className="title">Has Card</small>
                            <TextField  label="hasCard" source="hasCard" />    
                        </div>
                        <div className="flex-2">
                            <small className="title">Stripe Id</small>
                            <TextField  label="stripeId" source="stripeId" />    
                        </div>
                        <div className="flex-2">
                            <small className="title">Stripe Card Id</small>
                            <TextField  label="stripeCardId" source="stripeCardId" />    
                        </div>
                        <div className="flex-2">
                            <small className="title">Stripe Connect Id</small>
                            <TextField  label="stripeConnectId" source="stripeConnectId" />    
                        </div>
                </FormTab>
            </TabbedForm>
        </Show>
    );
};
